import clsx from 'clsx';

/** The tick box of the X Ads screens (the CRM's styled checkbox) with a plain `onChange(checked)`. */
export function XCheck({ checked, onChange, disabled, className, ariaLabel }: {
  checked: boolean; onChange: (checked: boolean) => void; disabled?: boolean; className?: string; ariaLabel?: string;
}) {
  return <input type="checkbox" checked={checked} disabled={disabled} aria-label={ariaLabel} className={clsx('shrink-0', className)}
    onChange={(e) => onChange(e.target.checked)} />;
}
